import BaseScene from "../../scenes/BaseScene";
import { RandomItem } from "../../interfaces/IContentModel";

export default class WordOptionComponent extends Phaser.GameObjects.Container {
  // a container is much like a html element, it has a parent (possible the scene or game world), and can have childen added via this.add
  private label: Phaser.GameObjects.Text;
  private currentOption: number;
  public currentCategory: number;
  public currentWord: string;
  private dataModel: RandomItem[];
  private bgOverlay: Phaser.GameObjects.Graphics;
  constructor(scene: BaseScene, x: number, y: number, dataModel: RandomItem[]) {
    // super to creat the container at the specified co-ordinates.
    super(scene, x, y);

    // !important - as we are using the 'new' keyword (and not using the scene
    // factory methods, `scene.add` ) we need to add it to the scene manually
    scene.add.existing(this);

    this.dataModel = dataModel;
    this.currentOption = Phaser.Math.RND.between(0, 2);
    this.currentCategory = this.dataModel[this.currentOption].category;
    this.currentWord = this.dataModel[this.currentOption].text;

    const bg = this.scene.add.image(
      0,
      0,
      "password-atlas",
      "textbox-randomiser.png"
    );
    this.add(bg);
    bg.setInteractive();
    bg.on("pointerdown", this.updateOption, this);

    this.label = this.scene.add
      .text(
        0,
        0,
        this.dataModel[this.currentOption].text,
        scene.sponge.data.model.fonts.button
      )
      .setFontSize(60)
      .setFontStyle("bold")
      .setOrigin(0.5);
    this.add(this.label);

    this.bgOverlay = this.scene.add.graphics({ x: 0, y: 0 });
    this.add(this.bgOverlay);

    this.add(bg);
    bg.setInteractive();
    bg.on("pointerdown", this.updateOption, this);
  }

  updateOption() {
    this.currentOption++;
    if (this.currentOption >= this.dataModel.length) {
      this.currentOption = 0;
    }

    this.currentCategory = this.dataModel[this.currentOption].category;
    this.currentWord = this.dataModel[this.currentOption].text;
    this.label.setText(this.currentWord);
  }

  showOverlay() {
    this.bgOverlay.clear();
    this.bgOverlay.fillStyle(0xff00ff, 0.5);
    this.bgOverlay.fillRect(-233, -77, 466, 154);
  }

  update(): void {
    // const delta = this.scene.time.
  }
}
